@if (examinationForms.length > 0) {
  <p>{{ text }}</p>
  <div class="my-4 flex flex-col gap-2">
    @for (examinationForm of examinationForms; track examinationForm.id) {
      <button tuiAppearance="outline" tuiCell tuiSurface type="button" (click)="select(examinationForm)">
        <div tuiTitle>
          {{ examinationForm.title }}
          @if (examinationForm.description) {
            <div tuiSubtitle>
              {{ examinationForm.description }}
            </div>
          }
        </div>
        <tui-icon icon="@tui.chevron-right" />
      </button>
    }
  </div>
} @else {
  <pxc-empty-state *transloco="let t" [title]="t('Aucun formulaire d\'examen')" />
}
